<nav class="nav-main flex-row">
  <div class="nav-left">
    <app-logo />
    <!--		<app-bug-report-button></app-bug-report-button>-->
  </div>
  <div class="nav-right flex-1">
    <div class="flex-row">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
      @if (IS_TRS_PROJECT) {
        @if (isReportModuleActive) {
          <a routerLink="/reports" routerLinkActive="active">
            {{ "navigation.reports" | translate }}
          </a>
        }

        @if (isSummaryReportModuleActive) {
          <a matTooltip="{{ 'navigation.summaryReportsTooltip' | translate }}" routerLink="/summary-reports" routerLinkActive="active">
            {{ "navigation.summaryReports" | translate }}
          </a>
        }

        @if (isOrganisationModuleActive) {
          <a
            matTooltip="{{ (isCascadedReportingActive ? 'navigation.org' : 'navigation.org2') | translate }}"
            routerLink="/org-charts"
            routerLinkActive="active">
            My Reporting Units
          </a>
        }
      } @else if (IS_PRODUCT_SAFETY_PROJECT) {
        @if (isReportModuleActive) {
          <a routerLink="/reports" routerLinkActive="active" matTooltip="{{ 'navigation.reports' | translate }}">Reports</a>
        }
        @if (isSummaryReportModuleActive) {
          <a matTooltip="{{ 'navigation.summaryReports' | translate }}" routerLink="/summary-reports" routerLinkActive="active"> Summary Reports </a>
        }

        @if (isOrganisationModuleActive) {
          <a
            matTooltip="{{ (isCascadedReportingActive ? 'navigation.org' : 'navigation.org2') | translate }}"
            routerLink="/org-charts"
            routerLinkActive="active">
            Organization
          </a>
        }
      }
      @if (isAdmin) {
        <a routerLink="/admin" routerLinkActive="active">{{ "navigation.admin" | translate }}</a>
      }
    </div>
  </div>
  <reporting-tool-user-menu (openFaq)="openFaq()" />
</nav>
@if (isFaqModuleActive) {
  <app-faq #faqComponent />
}
